import React from 'react'
import { useIntl } from 'react-intl'

import { TabLink, TabNav } from '@/components/atoms/TabLink'
import { cn } from '@/lib/utils'

export interface RegionPromotionTabsProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly initiativeId: string
  readonly regionId: string
  readonly activeTab: 'shop' | 'promotions'
  readonly actions?: React.ReactNode
}

export const RegionPromotionTabs = React.forwardRef<HTMLDivElement, RegionPromotionTabsProps>(
  ({ initiativeId, regionId, activeTab, actions, className, ...props }, ref) => {
    const intl = useIntl()
    return (
      <div
        ref={ref}
        className={cn('flex flex-wrap items-end justify-between gap-4 border-b border-gray-200', className)}
        {...props}>
        <TabNav aria-label={intl.formatMessage({ id: 'promotions.region.title' })}>
          <TabLink
            label={intl.formatMessage({ id: 'promotions.tabs.shop' })}
            to="/promotions/$initiativeId/$regionId/boutique"
            active={activeTab === 'shop'}
            params={{ initiativeId, regionId }}
          />
          <TabLink
            label={intl.formatMessage({ id: 'promotions.tabs.promotions' })}
            to="/promotions/$initiativeId/$regionId"
            active={activeTab === 'promotions'}
            params={{ initiativeId, regionId }}
          />
        </TabNav>
        {actions && <div className="flex items-center gap-4 pb-2">{actions}</div>}
      </div>
    )
  }
)
